import AccordionTextBlock from "@/components/AccordionTextBlock/AccordionTextBlock";
import { ContentBlock } from "@/components/ContentBlock/ContentBlock";
import type { FundDetailLayoutComponentProps } from "@/types/fundDetailLayout";

export const FxAdditionalInformationPanel = ({ dashboard, flex }: FundDetailLayoutComponentProps) => {
	const { fxAdditionalInformationPanel: props } = dashboard;

	if (!props) {
		return null;
	}

	return (
		<ContentBlock id="fxAdditionalInformationPanel" data-testid="FxAdditionalInformationPanel" tabIndex={-1}>
			<AccordionTextBlock {...props} />
		</ContentBlock>
	);
};
